import { useTranslation } from '@/translations/i18n'

/**
 * Pre-download green banner, shown once nothing is pending any more. Two
 * shapes: a bare "no walk-in resolution needed" line when the event never had
 * anything to resolve, or a summary of what the operator did (walk-ins
 * resolved, rows given up on) when it did.
 */
export function ExportResolvedBanner({
	resolvedCount,
	excludedCount
}: {
	resolvedCount: number
	excludedCount: number
}) {
	const { t } = useTranslation()
	const hasFacts = resolvedCount > 0 || excludedCount > 0

	if (!hasFacts) {
		return (
			<div className='rounded-airbnb-2xl border border-success-300 bg-success-50 px-6 py-5'>
				<p className='font-medium text-neutral-900 text-sm'>
					{t('marquee:export_resolved_none')}
				</p>
			</div>
		)
	}

	return (
		<div className='flex flex-col gap-1 rounded-airbnb-2xl border border-success-300 bg-success-50 px-6 py-5 text-sm'>
			<p className='font-medium text-neutral-900'>
				{t('marquee:export_resolved_title')}
			</p>
			<p className='max-w-3xl text-neutral-500'>
				{resolvedCount > 0 &&
					`${t('marquee:export_resolved_walk_ins', {
						count: resolvedCount
					})} `}
				{excludedCount > 0 &&
					`${t('marquee:export_resolved_excluded', {
						count: excludedCount
					})} `}
				{t('marquee:export_resolved_unlocked')}
			</p>
		</div>
	)
}
